import React from 'react'
import { Button } from 'antd'
import { Link } from './footerLinksData'
import { useLocation } from 'react-router-dom'
import { useModalStore } from '../../store/ModalStore'
import { useSmartNavigate } from '../../hooks/useSmartNavigate'

interface FooterLinksProps {
    links: Link[]
}

const FooterLinks: React.FC<FooterLinksProps> = ({ links }) => {
    const { openModal } = useModalStore()
    const smartNavigate = useSmartNavigate()
    const location = useLocation()

    const scrollToElement = (hash: string) => {
        const element = document.getElementById(hash)
        if (element) {
            // Get header height (80px on desktop, but check if it's sticky)
            const header = document.querySelector('.header')
            const isSticky =
                header && window.getComputedStyle(header).position === 'sticky'
            const headerOffset = isSticky ? 100 : 0 // Add extra padding for better visibility

            const elementPosition =
                element.getBoundingClientRect().top + window.pageYOffset
            const offsetPosition = elementPosition - headerOffset

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth',
            })
        }
    }

    const handleLinkClick = (link: Link) => {
        if (link.destination) {
            // Check if it's an anchor link (contains #)
            if (link.destination.includes('#')) {
                const [path, hash] = link.destination.split('#')
                const hashId = hash

                // If we're already on the target page, just scroll to the element
                if (
                    location.pathname === path ||
                    (path === '/' && location.pathname === '/')
                ) {
                    scrollToElement(hashId)
                } else {
                    // Navigate to the page, then scroll after navigation
                    smartNavigate(path)
                    // Use setTimeout to ensure the page has rendered
                    setTimeout(() => {
                        scrollToElement(hashId)
                    }, 100)
                }
            } else {
                // Use smartNavigate which handles same-page check automatically
                smartNavigate(link.destination)
            }
        } else if (link.onClickKey) {
            openModal(link.onClickKey)
        }
    }
    return (
        <div>
            {links.map((link) => (
                <Button
                    key={link.key}
                    type="link"
                    onClick={() => handleLinkClick(link)}
                >
                    {link.title}
                </Button>
            ))}
        </div>
    )
}

export default FooterLinks
